//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";

//css
import styled from "styled-components"

// component
import MyCancel from "./components/MyCancel"

export default function MyCancelPage() {

    return (
        <MyCancel/>
    );
  }
